import {HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {all} from 'deepmerge';

// See https://github.com/ngx-translate/core/issues/199#issuecomment-339084987
export class MultiTranslateHttpLoader implements TranslateLoader {

    /**
     * Fetch translation from ordering multiple resources :
     * if there has multiple definition of the same (leaf) key, the last one will be kept
     * @param http httpClient
     * @param resources ordering resources
     */
    constructor(private http: HttpClient,
        public resources: Array<FrontI18nResource>) {
    }

    /**
     * Load i18n resources related to a specific {@param lang}
     *
     * If there are multiple i18n resources with the same keys then
     * resource with higher priority overrides duplicated key found in resource with lower priority
     * @param lang Language as defined within Language enum values
     */
    public getTranslation(lang: string): Observable<any> {
        return forkJoin(this.resources
            .sort((a, b) => a.priority - b.priority)
            .map(config => {
                return this.http.get(`${config.prefix}${lang}${config.suffix}`)
                    .pipe(
                        catchError(err => {
                            console.error(`getTranslation error with lang ${lang}`, err);
                            return of({});
                        })
                    );
            }))
            .pipe(
                map(responses => all(responses))
            );
    }
}

/**
 * Represent a local i18n resource containing some i18n labels.
 *
 * Priority is useful when multiple resources are loaded and the same key has been defined several times:
 * the value defined in the resource with the highest priority will be used.
 */
export class FrontI18nResource {
    prefix: string;
    suffix: string;
    priority: number;

    constructor(prefix: string, suffix: string, priority: number) {
        this.prefix = prefix;
        this.suffix = suffix;
        this.priority = priority;
    }
}
